import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import '../../../Assets/Css/ViewInvoice.scss';
import { getPurchaseInvoices } from '../../../Services/Invoices/action';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

const ViewPurchaseinvoices = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location?.state?.data;
    const [viewData, setViewData] = useState({});
    const [fileLinks, setFileLinks] = useState([]);
    const purchaseInvoiceId = data?.checkbox?.value;

    const getPurchaseInvoiceData = async () => {
        try {
            await props.getPurchaseInvoices(location.search);
        } catch (error) {
            console.log("Error", error);
        }
    };

    useEffect(() => {
        if (purchaseInvoiceId) {
            getPurchaseInvoiceData();
        } else {
            toast.error("Something Went Wrong !");
            navigate("/purchaseinvoices");
        }
    }, []);

    useEffect(() => {
        props?.getPurchaseInvoices();
    }, []);

    useEffect(() => {
        setTheData();
        const urls = props?.purchaseInvoice
            ?.filter((item) => item.id === purchaseInvoiceId)
            ?.flatMap((item) => item?.purchaseinvoiceMap)
            ?.flatMap((item) => item.url);
        const fileLinksString = localStorage.getItem('fileLinks');
        let files = fileLinksString ? JSON.parse(fileLinksString) : [];
        files = files.filter((file) => urls.includes(file.link));
        setFileLinks(files);
    }, [props?.purchaseInvoice]);


    const setTheData = async () => {
        if (purchaseInvoiceId) {
            (await props?.purchaseInvoice && setViewData(await props?.purchaseInvoice));

        }
    };

    return (
            <div className='viewInvoice-main'>
                <div className="page-title">
                    <h4>View Purchase Invoice</h4>
                    <div className="edit-btn">
                        <button type="button" className="custom-btn">
                            <Link to='/purchaseinvoices/edit' style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>
                                {props.loading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        className="custom-spinner"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    "Edit"
                                )}
                            </Link>
                        </button>
                    </div>
                </div>
                {props.loading ? (
                    <div style={{
                        display: "flex",
                        justifyContent: "center"
                    }}>
                        <Spinner
                            as="span"
                            animation="border"
                            className="custom-spinner"
                            role="status"
                            aria-hidden="true"
                        />
                    </div>
                ) : (
                    <div className="content-part">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="left-part">
                                    <div className="invoice-details">
                                        <div className="invoice-details-content">
                                            <h6 className='label'>Seller Name</h6>
                                            <h6 className='value'>{data?.Seller?.value || "-"}</h6>
                                        </div>
                                        <div className="invoice-details-content">
                                            <h6 className='label'>Item Name</h6>
                                            <h6 className='value'>{data?.['Item-Name']?.value || "-"}</h6>
                                        </div>
                                        <div className="invoice-details-content">
                                            <h6 className='label'>Invoice Amount</h6>
                                            <h6 className='value'>{data?.['Invoice-Total']?.value || 0}</h6>
                                        </div>
                                        <div className="invoice-details-content">
                                            <h6 className='label'>Gst Amount</h6>
                                            <h6 className='value'>{data?.Gst?.value || 0}</h6>
                                        </div>
                                        <div className="invoice-details-content">
                                            <h6 className='label'>Shareholder</h6>
                                            <h6 className='value'>{data?.['Share Holders']?.value?.map((sh) => sh.name).join(', ') === "Ahmedabad" ? "Rajan, Aditi" : data?.['Share Holders']?.value?.map((sh) => sh.name).join(', ') || "-"}</h6>
                                        </div>
                                        <div className="invoice-details-content">
                                            <h6 className='label'>Purchase Date</h6>
                                            <h6 className='value'>
                                                {data?.Date?.value || "-"}
                                            </h6>
                                        </div>
                                        <div className="invoice-details-content">
                                            <h6 className='label'>Google Drive Link</h6>
                                            <div style={{ display: 'grid' }}>
                                                {fileLinks?.reverse().map((item, index) => (
                                                    <div key={index}>
                                                        <a className='value' href={item.link} target="_blank" rel="noopener noreferrer">
                                                            {item.link}
                                                        </a>
                                                        <h6 className='value'>{item.name}</h6>
                                                    </div>
                                                )) || "-"}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
    );
}

const mapStateToProps = (state) => {
    return {
        loading: state.invoicesReducer.loading,
        purchaseInvoice: state.invoicesReducer.purchaseInvoice,
    }
}

const mapDispatchToProps = {
    getPurchaseInvoices: getPurchaseInvoices
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewPurchaseinvoices);
